import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="video-background"
        >
          <source src="img/hero.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark overlay for readability */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 intro-text">
              <h2>
                {props.data ? props.data.title : "Loading"}
                <span></span>
              </h2>
              <p>{props.data ? props.data.paragraph : "Loading"}</p>
              <a
                href="#features"
                className="btn btn-custom btn-lg page-scroll"
              >
                Learn More
              </a>{" "}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
